<template>
<svg v-if="visible" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<path d="M3 3l18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
<path d="M10.58 10.58a2 2 0 0 0 2.83 2.83" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.88 5.09A9.77 9.77 0 0 1 12 4.86c5 0 9 4.14 10 7.14-.43 1.29-1.37 2.83-2.74 4.17M6.61 6.61C4.6 7.95 3.11 9.97 2 12c1 3 5 7.14 10 7.14 1.76 0 3.38-.51 4.79-1.32" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
</svg>
</template>

<script>
export default {
  name: 'IconVisibility',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
};
</script>
